export type RealRegionId =
  | 'moscow'
  | 'spb'
  | 'rostov'
  | 'novorossiysk'
  | 'yaroslavl'
  | 'kaluga'
  | 'obninsk'
  | 'perm'
  | 'ekb'
  | 'tyumen';

export type RegionId = RealRegionId | 'any';

export type Region = RegionId | number;

export const defaultRegionId: Region = 'moscow';
export const moscowBackendId = -1;

export interface IRegion {
  readableId: Region;
  backendId: number;
  coordinates: [number, number];
  officePhone: string;
}

export const moscowPhone = '+74951348244';
export const moscowCoords: [number, number] = [55.755814, 37.617635];

export const regionsInfo: IRegion[] = [
  {
    // Все регионы
    backendId: 0,
    coordinates: moscowCoords,
    officePhone: moscowPhone,
    readableId: 'any',
  },
  {
    // Москва и МО
    backendId: moscowBackendId,
    coordinates: moscowCoords,
    officePhone: moscowPhone,
    readableId: 'moscow',
  },
  {
    // Санкт-Петербург
    backendId: -2,
    coordinates: [59.939095, 30.315868],
    officePhone: '+78123325466',
    readableId: 'spb',
  },
  {
    // Ростов-на-Дону
    backendId: 4959,
    coordinates: [47.222555, 39.718678],
    officePhone: '+78633221147',
    readableId: 'rostov',
  },
  {
    // Новороссийск
    backendId: 4896,
    coordinates: [44.723566, 37.768678],
    officePhone: '+78617306135',
    readableId: 'novorossiysk',
  },
  {
    // Ярославль
    backendId: 5075,
    coordinates: [57.626569, 39.893787],
    officePhone: '+74852235925',
    readableId: 'yaroslavl',
  },
  {
    // Калуга
    backendId: 4780,
    coordinates: [54.513845, 36.261215],
    officePhone: '+74842212462',
    readableId: 'kaluga',
  },
  {
    // Обнинск
    backendId: 4908,
    coordinates: [55.112005, 36.586531],
    officePhone: '+74842212475',
    readableId: 'obninsk',
  },
  {
    // Пермь
    backendId: 4927,
    coordinates: [58.010374, 56.229398],
    officePhone: '+73422250087',
    readableId: 'perm',
  },
  {
    // Екатеринбург
    backendId: 4743,
    coordinates: [56.838011, 60.597465],
    officePhone: '+73433022670',
    readableId: 'ekb',
  },
  {
    // Тюмень
    backendId: 5024,
    coordinates: [57.153033, 65.534328],
    officePhone: '+73452492471',
    readableId: 'tyumen',
  },
];

export function isValidRegion(region: string): region is RegionId {
  return regionsInfo.map(r => r.readableId).includes(region as RegionId);
}

export function getBackendLocationId(realRegionId: RealRegionId): number {
  const region = regionsInfo.find(r => r.readableId === realRegionId);

  return region ? region.backendId : moscowBackendId;
}

export function getReadableLocationId(backendId: number): Region | undefined {
  const region = regionsInfo.find(r => r.backendId === backendId);

  return region && region.readableId;
}

export function getRegionCenter(locationId: Region): [number, number] {
  const region = regionsInfo.find(r => r.readableId === locationId);

  return region ? region.coordinates : moscowCoords;
}

export function getRegionPhone(locationId: Region): string {
  const region = regionsInfo.find(r => r.readableId === locationId);

  return region ? region.officePhone : moscowPhone;
}

export function getSelectedRegionId(region: Region): RealRegionId | undefined | 'any' {
  if (typeof region === 'number') {
    return getReadableLocationId(region) as RealRegionId;
  }

  return region;
}
